module.exports = __webpack_public_path__ + "images/emoji/point_left.4acf0e7e028fd4e109e6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/point_left.png
// module id = /CEf
// module chunks = 24